import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import 'lib/reactBootstrapReact19/modal'
import 'lib/reactBootstrapReact19/button'
import styles from './index.module.scss'
import B2BVerificationMsg from './VerificationMessageModal'
import useAppSelector from 'hooks/useAppSelector'
import { useDispatch } from 'react-redux'
import {
  modifyURLQuery,
  removeKeywordFromStoredSearchQuery,
} from 'utils/common'
import { useRouter } from 'next/router'
import _omit from 'lodash/omit'
import { setB2BDetails } from 'state/booking/actions'

type B2bVerifyMessageModalProps = {
  handleChangeB2bFormModal?: (updatedValue: boolean) => void
  handleChangeB2bMessageModal: (updatedValue: boolean) => void
}

const B2bVerifyMessageModal: React.FC<B2bVerifyMessageModalProps> = ({
  handleChangeB2bFormModal = null,
  handleChangeB2bMessageModal,
}) => {
  const router = useRouter()
  const { query } = router
  const { partnershipCode } = query
  const { b2bUserDetails } = useAppSelector((state) => state.bookingHelper)
  const { isB2BUser, verificationMessages, keyword } = b2bUserDetails ?? {}
  const dispatch = useDispatch()
  const b2bMessageModalTitle =
    isB2BUser && partnershipCode === keyword
      ? 'Great, we found your benefits!'
      : 'Unable to verify partnership'

  const onResetKeyword = () => {
    dispatch(setB2BDetails(undefined))
    const modifiedQueryWithoutKeyword = _omit(query, ['partnershipCode'])
    modifyURLQuery(router, modifiedQueryWithoutKeyword, true)
    removeKeywordFromStoredSearchQuery()
    handleChangeB2bMessageModal(false)
    !!handleChangeB2bFormModal && handleChangeB2bFormModal(true)
  }

  return (
    <Modal
      centered
      dialogClassName={styles.b2bModal}
      show={true}
      backdrop="static"
      onHide={() => handleChangeB2bMessageModal(false)}
      contentClassName={styles.b2bVerifyModalContentVerifyMessages}
    >
      <Modal.Header className={styles.b2bVerifyFormModalHeader} closeButton>
        <Modal.Title className={styles.b2bVerifyMessageModalTitle}>
          {b2bMessageModalTitle}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.b2bVerifyMessageModalBody}>
        <B2BVerificationMsg
          message={{
            successMsg: verificationMessages?.customSuccessMessage,
          }}
          isSuccess={isB2BUser}
        />
      </Modal.Body>
      <Modal.Footer className={styles.b2bModalFooter}>
        <Button
          className={styles.b2bVerifyMessageGoBackBtn}
          onClick={onResetKeyword}
        >
          <div className={styles.b2bVerifyMessageGoBackBtnText}>
            Reset Keyword
          </div>
        </Button>
        <Button
          className={styles.b2bVerifyMessageDismissBtn}
          onClick={() => handleChangeB2bMessageModal(false)}
        >
          <div className={styles.b2bVerifyMessageDismissBtnText}>Close</div>
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default B2bVerifyMessageModal
